import { PanelLeftCloseIcon } from 'lucide-react';

import { SidebarTrigger, SidebarHeader } from '@/components/ui/sidebar';

export function NavHeader() {
  return (
    <SidebarHeader className={'flex flex-row justify-between gap-0'}>
      <span className="bg-brand-accent/50 dark:bg-brand/7 absolute -top-20 -left-20 size-60 rounded-full blur-2xl transition-opacity duration-150 group-data-[state=collapsed]:opacity-0" />
      <img src={'/logo.png'} alt="" className={'transition-scale z-20 block aspect-square size-10 duration-100 group-data-[state=collapsed]:w-0 group-data-[state=collapsed]:scale-0'} />
      <SidebarTrigger variant={'ghost'} className={'hidden w-fit md:flex'}>
        <PanelLeftCloseIcon className={'transition-transform duration-150 group-data-[state=collapsed]:rotate-180'} />
      </SidebarTrigger>
    </SidebarHeader>
  );
}
